module.exports = __webpack_public_path__ + "img/iconTC.ee4c341c.png";